<script setup lang="ts">
type SurveyTraderInfo = {
  localName?: string
  shortName?: string
  defaultName?: string
  localShortName?: string
  ico?: string
  logo?: string
  showName?: string
}

type SurveyMapItem = {
  related?: SurveyTraderInfo | null
  trader?: SurveyTraderInfo | null
  [key: string]: unknown
}

const CLOSE_ICON = 'https://resources1.interface003.com/web30/2026/06/08/2af6f5ee-7ed0-4d4b-8dff-dcf5540ccb14.png'

const { t } = useAppI18n()
/** 组件入参 */
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    item?: SurveyMapItem | null
    useGoogleMap?: boolean
  }>(),
  {
    item: null,
    useGoogleMap: false,
  },
)

/** 更新事件 */
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

/** 当前显示状态 */
const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

/** 交易商数据 */
const traderInfo = computed(() => props.item?.related || props.item?.trader || {})

/** 交易商名称 */
const traderName = computed(
  () =>
    traderInfo.value.showName ||
    traderInfo.value.defaultName ||
    traderInfo.value.localName ||
    traderInfo.value.shortName ||
    traderInfo.value.defaultName ||
    traderInfo.value.localShortName ||
    '--',
)

/** 交易商图标 */
const traderIcon = computed(() => traderInfo.value.ico || traderInfo.value.logo || '')

/** 关闭弹窗 */
function closeDialog() {
  visible.value = false
}
</script>

<template>
  <ClientOnly>
    <ElDialog
      v-model="visible"
      width="1000px"
      :show-close="false"
      class="xy-fixed !m-0 !overflow-hidden !rounded-[32px] !bg-[transparent] !p-0"
      body-class="!p-0 !bg-[transparent]"
      header-class="hidden"
    >
      <div class="flex flex-col bg-white px-[32px] pt-[32px]">
        <div class="flex items-start gap-[8px] border-b-[0.5px] border-[rgba(5,21,36,0.06)] pb-[16px]">
          <div class="min-w-0 flex-1">
            <p class="truncate text-[20px] leading-[28px] font-[600] text-[#292a2e]">{{ t('84281') }}</p>

            <div class="mt-[8px] flex items-center gap-[12px]">
              <div class="flex min-w-0 items-center gap-[4px]">
                <CommonImage
                  v-if="traderIcon"
                  :src="traderIcon"
                  :alt="traderName"
                  class="h-[20px] w-[20px] shrink-0 rounded-[2px] object-cover"
                  loading="lazy"
                />
                <span class="truncate text-[14px] leading-[22px] text-[#7d818a]">
                  {{ traderName }}
                </span>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="flex h-[32px] w-[32px] shrink-0 cursor-pointer items-center justify-center hover:opacity-80"
            @click="closeDialog"
          >
            <CommonImage class="h-[32px] w-[32px]" :src="CLOSE_ICON" alt="close" />
          </button>
        </div>
      </div>

      <div class="bg-white px-[32px] pt-[20px] pb-[32px]">
        <SurveyGoogleMap v-if="props.useGoogleMap" :item="props.item" />
        <SurveyBaiduMap v-else :item="props.item" />
      </div>
    </ElDialog>
  </ClientOnly>
</template>
